import type { TransitOrganization } from '@/types';

/**
 * SOCIÉTÉ DE TRANSPORT DE MONTRÉAL
 */
export const stmOrganization: TransitOrganization = {
  id: 'stm',
  homepageLink: {
    url: 'https://www.stm.info/',
    friendlyName: 'stm.info',
  },
  paratransit: {
    homepageLink: {
      url: 'https://www.stm.info/fr/ta',
      friendlyName: null,
    },
    bookingService: {
      phone: {
        number: '5142808211',
        option: '1',
      },
      openingHours: {
        lowerBound: '08:00',
        upperBound: '19:00',
        openingDays: 'all',
      },
    },
    assistanceService: {
      openingHours: {
        lowerBound: '08:00',
        upperBound: '17:00',
        openingDays: 'all',
      },
    },
    customerService: {
      email: 'transport.adapte@stm.info',
      phone: {
        number: '5142808211',
        option: '4',
      },
      openingHours: {
        lowerBound: '08:30',
        upperBound: '16:30',
        openingDays: 'weekdays',
        holidayOpeningHours: false,
      },
    },
  },
};

/**
 * SOCIÉTÉ DE TRANSPORT DE LAVAL
 */
export const stlOrganization: TransitOrganization = {
  id: 'stl',
  homepageLink: {
    url: 'https://www.stlaval.ca/',
    friendlyName: 'stlaval.ca',
  },
  paratransit: {
    homepageLink: {
      url: 'https://stlaval.ca/transport-adapte/info',
      friendlyName: null,
    },
    bookingService: {
      phone: {
        number: '4509733111',
        option: '1',
      },
      openingHours: {
        lowerBound: '08:00',
        upperBound: '19:00',
        openingDays: 'all',
      },
    },
    assistanceService: {
      openingHours: {
        lowerBound: '08:00',
        upperBound: '17:00',
        openingDays: 'all',
      },
    },
    customerService: {
      email: null,
      phone: {
        number: '4506886520',
        option: null,
      },
      openingHours: {
        lowerBound: '07:00',
        upperBound: '19:00',
        openingDays: 'weekdays',
        holidayOpeningHours: {
          lowerBound: '08:00',
          upperBound: '17:00',
        },
      },
    },
  },
};
